import { useState, useEffect } from "react";

/**
 * Device detection aligned with shell chrome breakpoints.
 * Mobile chrome (header + bottom tabs) uses Tailwind `lg` (1024px):
 * phones and tablets keep the tab bar; desktop gets the sidebar.
 */
function readDeviceSnapshot() {
  if (typeof window === "undefined") {
    return {
      deviceType: "desktop",
      isMobile: false,
      isTablet: false,
      isDesktop: true,
      isTouchDevice: false,
    };
  }
  const width = window.innerWidth;
  const touchDevice =
    "ontouchstart" in window ||
    navigator.maxTouchPoints > 0 ||
    navigator.msMaxTouchPoints > 0;
  // Compact layout: phones + tablets (< lg). Matches shell mobile chrome.
  if (width < 1024) {
    const isPhone = width < 768;
    return {
      deviceType: isPhone ? "mobile" : "tablet",
      isMobile: true,
      isTablet: !isPhone,
      isDesktop: false,
      isTouchDevice: touchDevice,
    };
  }
  return {
    deviceType: "desktop",
    isMobile: false,
    isTablet: false,
    isDesktop: true,
    isTouchDevice: touchDevice,
  };
}

export const useDeviceDetection = () => {
  const [snap, setSnap] = useState(readDeviceSnapshot);

  useEffect(() => {
    const checkDevice = () => {
      setSnap(readDeviceSnapshot());
    };

    checkDevice();

    let resizeTimeout;
    const handleResize = () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(checkDevice, 150);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      clearTimeout(resizeTimeout);
    };
  }, []);

  return snap;
};
